export const hero = {
positioning: 'One More Global Inc.',
title: 'Bienestar. Cuidado Personal. Venta Directa.',
subtitle: 'Productos de consumo de calidad respaldados por operaciones disciplinadas, desarrollo de mercado responsable y relaciones comerciales a largo plazo.',
cta_structure: 'Ver Estructura Corporativa',
cta_contact: 'Contactar Oficina Corporativa',
location: 'Houston, Texas, EE. UU.',
stat_1_value: 'Américas',
stat_1_label: 'Cobertura Regional',
stat_2_value: 'Houston, TX',
stat_2_label: 'Sede Central',
stat_3_value: 'Venta Directa',
stat_3_label: 'Modelo de Negocio',
};
